import { Link, useLocation, useNavigate } from "react-router-dom";
import { Breadcrumb, BreadcrumbItem, BreadcrumbLink, Button } from "@chakra-ui/react";

function BreadcrumbMenu() {
  const navigate = useNavigate();
  const location = useLocation();
  const segments = location.pathname.split("/").slice(1);

  const capitalize = (str: string) => {
    return str.charAt(0).toUpperCase() + str.slice(1);
  };

  const formatBreadcrumbLabel = (segment: string) => {
    return capitalize(segment).replace("-", " ");
  };

  return (
    <div style={styles.container}>
      <Breadcrumb fontSize="sm">
        <BreadcrumbItem>
          <BreadcrumbLink as={Link} to="/admin">
            Dashboard
          </BreadcrumbLink>
        </BreadcrumbItem>

        {segments.slice(1, 3).map((segment, index) => (
          <BreadcrumbItem key={index} style={{ textWrap: 'nowrap' }}>
            <BreadcrumbLink>{formatBreadcrumbLabel(segment)}</BreadcrumbLink>
          </BreadcrumbItem>
        ))}
      </Breadcrumb>

      <div>
        <Button
          size="sm"
          variant="outline"
          colorScheme="telegram"
          onClick={() => navigate(-1) }
        >
          Go back
        </Button>
      </div>
    </div>
  );
};

const styles: { [key: string]: React.CSSProperties } = {
  container: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "10px 20px",
    paddingLeft: 0,
    position: 'relative',
    left: 10,
  },
};

export default BreadcrumbMenu;
